<template>
  <div v-if="item">
    <ul class="nav nav-tabs nav-justified pb-4">
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('tabConclusion')"
          :class="{ active: isActive('tabConclusion') }"
          href="#tabConclusion"
          >Заключение ПМПК<i
            class="fas fa-info-circle text-danger ml-2"
            v-if="tabConclusionInvalid"
          ></i
        ></a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('tabSiprIomAop')"
          :class="{ active: isActive('tabSiprIomAop') }"
          href="#tabSiprIomAop"
          >СИПР/ИОМ/АОП<i
            class="fas fa-info-circle text-danger ml-2"
            v-if="tabSiprIomAopInvalid"
          ></i
        ></a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('tabCommonEdu')"
          :class="{
            active: isActive('tabCommonEdu'), 
            'marker-new': parsedStatusOfChange.dataSchool.active
          }"
          href="#tabCommonEdu"
          >Дошкольное и общее образование<i
            class="fas fa-info-circle text-danger ml-2"
            v-if="tabCommonEduInvalid"
          ></i
        ></a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('tabAddEdu')"
          :class="{ active: isActive('tabAddEdu') }"
          href="#tabAddEdu"
          >Дополнит. образование<i
            class="fas fa-info-circle text-danger ml-2"
            v-if="tabAddEduInvalid"
          ></i
        ></a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('tabProfEdu')"
          :class="{ 
            active: isActive('tabProfEdu'), 
            'marker-new': parsedStatusOfChange.dataSchoolProf.active
          }"
          href="#tabProfEdu"
          >Профессионал. образование<i
            class="fas fa-info-circle text-danger ml-2"
            v-if="tabProfEduInvalid"
          ></i
        ></a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('tabProf')"
          :class="{ active: isActive('tabProf') }"
          href="#tabProf"
          >Трудоустройство<i
            class="fas fa-info-circle text-danger ml-2"
            v-if="tabProfInvalid"
          ></i
        ></a>
      </li>
    </ul>
    <div class="tab-content card-content" id="routeTabContent">
      <div
        class="tab-pane fade"
        :class="{ 'active show': isActive('tabConclusion') }"
        id="tabConclusion"
        v-disable-all="isReadonly"
      >


        <div class="d-flex justify-content-end justify-content-between">
          <div class="w-100">
          </div>
          <div class="d-flex w-100 justify-content-end mb-4 actions">
            <button-component class="width-auto" 
              v-if="!isReadonly" 
              :disabled="modals.pmpkConclusionInProgress" 
              @click="openCardConclusion(0, false)">
                <i class="fa fa-spinner fa-spin mr-2" v-if="modals.pmpkConclusionInProgress"> </i>
                Создать
              </button-component>
          </div>

        </div>
        <!-- таблица всех заключений ПМПК -->
        <table class="table-custom">
              <thead>
                <tr>
                  <th></th>
                  <th>№&nbsp;заключения</th>
                  <th>Дата прохождения</th>
                  <th>Уроверь образования</th>
                  <th>Статус</th>
                  <th>Дата создания</th>
                  <th>Дата архивирования</th>
                  <th>Автор</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="conclusion in item.conclusions" :key="conclusion.id">
                  <td><menu-component class="actions" :actions="actionsConclusion(conclusion)" /></td>
                  <!-- <td>
                    <template v-if="conclusion.isArchive || isReadonly">
                      <a href="javascript:" @click="openCardConclusion(conclusion.id, true)">Просмотр</a>
                    </template>
                    <template v-else>
                      <a href="javascript:" @click="openCardConclusion(conclusion.id, false)">Редактировать</a>
                    </template>
                  </td> -->
                  <td>{{ conclusion.number }}</td>
                  <td>{{ $momentFormat(conclusion.passDate, "DD.MM.YYYY") }}</td>
                  <td>{{ conclusion.educationalProgram?.educationLevel?.name }}</td>
                  <td>{{ conclusion.isArchive ? "Архив" : "Действующий" }}</td>
                  <td>{{ $momentFormat(conclusion.created, "DD.MM.YYYY HH:mm") }}</td>
                  <td>{{ conclusion.isArchive ? $momentFormat(conclusion.archiveDate, "DD.MM.YYYY HH:mm") : "" }}</td>
                  <td>{{ conclusion.user.fullName }}</td>
                </tr>
                <tr v-if="!item.conclusions">
                  <td colspan="8">Список пуст</td>
                </tr>
              </tbody>
            </table>

        <div class="general-info" v-if="false">
          <div class="general-info__wrapper">
            <div class="row" v-if="item.conclusion.isArchive">
              <div class="form-group col-3">
                <label class="control-label">Дата архивирования</label>
                <div>
                  {{
                    $momentFormat(
                      item.conclusion.archiveDate,
                      "DD.MM.YYYY HH:mm"
                    )
                  }}
                </div>
              </div>
              <div class="form-group col-9">
                <label class="control-label">Автор</label>
                <div>{{ item.conclusion.user.fullName }}</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-3 required">
                <label class="control-label">№ заключения</label>
                <ComponentInput
                  v-model="item.conclusion.number"
                  :max-length="100"
                  required
                />
              </div>
              <div class="form-group col-3 required">
                <label class="control-label">Дата прохождения ПМПК</label>
                <date-component
                  :clearable="false"
                  :disabled="isReadonly"
                  v-model="item.conclusion.passDate"
                  :required="true"
                  scopeName="tabConclusion"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-6 select2 required">
                <component-input
                  label="ПМПК"
                  scopeName="tabConclusion"
                  type="select2"
                  required
                  :select2Options="pmpkPlacements"
                  :select2Settings="select2Settings"
                  v-model="item.conclusion.pmpkPlacementId"
                />
              </div>
              <div
                v-if="Number(item.conclusion.pmpkPlacementId) === 2"
                class="form-group col-6 select2 required"
              >
                <component-input
                  label="Муниципальный район"
                  scopeName="tabConclusion"
                  type="select2"
                  required
                  :select2Options="districts"
                  :select2Settings="select2Settings"
                  v-model="item.conclusion.districtId"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 required">
                <label class="control-label">Выводы комиссии</label>
                <textarea
                  class="form-control"
                  v-model="item.conclusion.commissionConclusions"
                  rows="3"
                ></textarea>
                <div
                  class="invalid-msg"
                  v-if="v$.item.conclusion.commissionConclusions.$error"
                >
                  Введите данные
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 select2 required">
                <component-input
                  label="Уровень образования"
                  scopeName="tabConclusion"
                  type="select2"
                  required
                  :select2Options="educationLevels"
                  :select2Settings="select2Settings"
                  v-model="eduLevelId"
                  v-on:select2OnSelect="loadEducationalPrograms"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 select2 required">
                <component-input
                  label="Образовательная программа"
                  scopeName="tabConclusion"
                  type="select2"
                  required
                  :select2Options="educationalPrograms"
                  :select2Settings="select2Settings"
                  v-model="item.conclusion.educationalProgramId"
                  v-on:select2OnSelect="loadRecommendations"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-6 select2 required">
                <component-input
                  label="Срок реализации"
                  scopeName="tabConclusion"
                  type="select2"
                  required
                  :select2Options="realizationTerms"
                  :select2Settings="select2Settings"
                  v-model="item.conclusion.realizationTermId"
                />
              </div>
              <div class="form-group col-6 select2 required">
                <component-input
                  label="Срок повторного обследования"
                  scopeName="tabConclusion"
                  type="select2"
                  required
                  :select2Options="repeatPeriods"
                  :select2Settings="select2Settings"
                  v-model="item.conclusion.repeatPeriodId"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 select2">
                <label class="control-label">Специальные методы обучения</label>
                <ComponentInput
                  v-model="item.conclusion.specialTeachingMethods"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 select2">
                <label class="control-label"
                  >Специальные учебные пособия и дидактические материалы</label
                >
                <Select2
                  :options="specialTutorials"
                  :settings="{ multiple: true, language: 'ru' }"
                  v-model="item.conclusion.specialTutorials"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 select2">
                <label class="control-label"
                  >Специальные ТСО коллективного и индивидуального
                  пользования</label
                >
                <Select2
                  :options="specialTso"
                  :settings="{ multiple: true, language: 'ru' }"
                  v-model="item.conclusion.specialTso"
                />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12 select2">
                <label class="control-label">Сопровождение специалистами</label>
                <Select2
                  :options="specialists"
                  :settings="{ multiple: true, language: 'ru' }"
                  v-model="item.conclusion.specialists"
                />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12">
                <label class="control-label">Другие специальные условия</label>
                <textarea
                  class="form-control"
                  v-model="item.conclusion.specialConditions"
                  rows="3"
                ></textarea>
              </div>
            </div>

            <h5>
              Рекомендации по психолого-педагогическому и логопедическому
              сопровождению
            </h5>
            <div class="row">
              <div class="form-group col-12 select2">
                <label class="control-label">по педагогическому</label>
                <Select2
                  :options="recom.pedagogical"
                  :settings="{ multiple: true, language: 'ru' }"
                  v-model="item.conclusion.recomPedagogical"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 select2">
                <label class="control-label">по психологическому</label>
                <Select2
                  :options="recom.psychological"
                  :settings="{ multiple: true, language: 'ru' }"
                  v-model="item.conclusion.recomPsychological"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 select2">
                <label class="control-label">по логопедическому</label>
                <Select2
                  :options="recom.speechtherapy"
                  :settings="{ multiple: true, language: 'ru' }"
                  v-model="item.conclusion.recomSpeechTherapy"
                />
              </div>
            </div>
            <hr />

            <div class="row">
              <div class="form-group col-12">
                <label class="control-label"
                  >Рекомендации по прохождению ГИА по ОП основного и среднего
                  общего образования</label
                >
                <textarea
                  class="form-control"
                  v-model="item.conclusion.recomGia"
                  rows="3"
                ></textarea>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">Копия заключения</label>
                  <file-upload
                    width="300px"
                    :entity="item.conclusion"
                    @deleteFile="removeConclusionCopyFile"
                    prop-name="conclusionCopy"
                    @uploaded="conclusionCopyFileUploaded"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group required">
                  <label class='control-label'>Информированное согласие родителя на обследование ребенка</label>
                  <file-upload width="300px" :entity="item.conclusion"
                               @deleteFile="removeConclusionConsentFile"
                               prop-name="parentConsent"
                               @uploaded="conclusionConsentCopyFileUploaded"/>
                  <div class="invalid-msg" v-if="v$.item.conclusion.parentConsentId.$error">
                    Загрузите файл
                  </div>
                </div>
              </div>
            </div> -->
            <div class="row">
              <div class="col-md-12">
                <div class="form-group required">
                  <label class="control-label"
                    >Согласие на добавление заключения ПМПК в Регистр
                    ЛРАС</label
                  >
                  <file-upload
                    width="300px"
                    :entity="item.conclusion"
                    @deleteFile="removeConclusionConsentToAddFile"
                    prop-name="consentToAdd"
                    @uploaded="conclusionConsentToAddFileUploaded"
                  />
                  <div
                    class="invalid-msg"
                    v-if="v$.item.conclusion.consentToAddId.$error"
                  >
                    Загрузите файл
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12">
                <label class="control-label">Иные документы</label>
                <div class="general-info__wrapper">
                  <div class="form-group form-group--files">
                    <div class="d-flex flex-column">
                      <div v-if="!item.conclusion.files.length">
                        Нет прикрепленных файлов
                      </div>
                      <div class="d-flex flex-column">
                        <div
                          v-for="(file, index) in item.conclusion.files"
                          :key="index"
                        >
                          <div class="d-flex align-items-center">
                            <div class="flex-column">
                              <FileUpload
                                width="300px"
                                @deleteFile="removeFile(index)"
                                :entity="file"
                                prop-name="file"
                                :entity-index="index"
                                @uploaded="fileUploaded"
                                :readonly="isReadonly"
                              />
                            </div>
                          </div>
                        </div>
                        <button
                          class="btn btn-addFile shadow-none"
                          title="Добавить"
                          @click="addFile"
                          v-if="!isReadonly"
                        >
                          Прикрепить документ
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button-component
            class="btn btn-primary mx-2 my-2 width-auto"
            v-if="item.conclusion.isArchive"
            v-on:click="closeArchivedConclusion()"
            >Вернуться к текущему заключению
          </button-component>
          <div v-if="conclusionArchive.length">
            <a href="javascript:" @click="toggleConclusionArchive"
              >Архив
              <i
                :class="
                  'ml-1 fas fa-chevron-' +
                  (conclusionArchiveVisible ? 'up' : 'down')
                "
              ></i>
            </a>
          </div>
          <div v-if="conclusionArchiveVisible">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Дата создания</th>
                  <th>Дата архивирования</th>
                  <th>Автор</th>
                  <th>№ заключения</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="entry in conclusionArchive">
                  <td>
                    <a
                      href="javascript:"
                      @click="openArchivedConclusion(entry)"
                      >{{ $momentFormat(entry.created, "DD.MM.YYYY HH:mm") }}</a
                    >
                  </td>
                  <td>
                    {{ $momentFormat(entry.archiveDate, "DD.MM.YYYY HH:mm") }}
                  </td>
                  <td>{{ entry.user.fullName }}</td>
                  <td>{{ entry.number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <button-component
            class="btn btn-primary mt-4 width-auto"
            v-if="!!item.conclusion.id && !item.conclusion.isArchive"
            v-on:click="createConclusionVersion()"
            >Создать
          </button-component>
        </div>
        <div class="card-footer mt-5">
          <div class="d-flex align-items-center float-right">
            <!-- <button-component
              class="btn btn-primary mx-2 width-auto"
              v-on:click="saveConclusion()"
              v-if="!isReadonly"
              >Сохранить</button-component
            > -->
            <button-component
              kind="secondary"
              type="button"
              class="btn btn-default width-auto"
              v-on:click="close"
              data-ignore-disable="true"
            >
              Закрыть</button-component
            >
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'active show': isActive('tabSiprIomAop') }"
        id="tabSiprIomAop"
        v-disable-all="isReadonly"
      >
        <form class="general-info" ref="formSiprIomAop">
          <button-component
            class="btn btn-primary mx-2 my-2 width-auto"
            v-on:click="addDocument()"
          >
            Добавить документ
          </button-component>
          <div
            v-for="(doc, index) in item.documents"
            :key="index"
            class="general-info__wrapper"
          >
            <div
              class="form-group d-flex flex-wrap align-items-center solid pl-3 justify-content-between"
            >
              <h5 class="m-0">{{ doc.documentNumber }}</h5>
              <button-component
                v-if="!isReadonly"
                class="justify-content-center btn-sm card-footer__btn white my-2 width-auto"
                @click="deleteDocument(index)"
              >
                Удалить
              </button-component>
            </div>
            <div class="row">
              <div class="form-group col-4 required">
                <label class="control-label">Дата документа</label>
                <date-component
                  :disabled="isReadonly"
                  :required="true"
                  v-model="doc.documentDate"
                  scopeName="tabSiprIomAop"
                />
              </div>
              <div class="form-group col-8 required">
                <ComponentInput
                  label="Номер документа"
                  v-model="doc.documentNumber"
                  required
                  scopeName="tabSiprIomAop"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12">
                <label class="control-label">Комментарий</label>
                <textarea
                  class="form-control"
                  v-model="doc.comment"
                  rows="3"
                ></textarea>
              </div>
            </div>
            <div class="row border-bottom mb-4">
              <div class="form-group col-4">
                <div class="d-flex align-items-center">
                  <div class="flex-column">
                    <FileUpload
                      :entity="doc"
                      prop-name="file"
                      :entity-index="index"
                      :readonly="isReadonly"
                      :required="true"
                      @uploaded="documentFileUploaded"
                      @deleteFile="removeFileSipr(doc)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer mt-5">
            <div class="d-flex align-items-center float-right">
              <button-component
                class="btn btn-primary mx-2 width-auto"
                v-on:click="saveDocuments()"
                v-if="!isReadonly"
                >Сохранить</button-component
              >
              <button-component
                kind="secondary"
                type="button"
                class="btn btn-default width-auto"
                v-on:click="close"
                data-ignore-disable="true"
                >Закрыть</button-component
              >
            </div>
          </div>
        </form>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'active show': isActive('tabCommonEdu') }"
        id="tabCommonEdu"
        v-disable-all="isReadonly"
      >
        <div class="general-info">
          <button-component
            class="btn btn-primary mx-2 my-2 width-auto"
            v-on:click="addOrganization(EducationCommon)"
            >Добавить ОУ
          </button-component>
          <div
            v-for="(edu, index) in commonEducations"
            class="general-info__wrapper"
            v-disable-all="edu.readOnly"
          >
            <div
              class="form-group d-flex flex-wrap align-items-center solid pl-3 justify-content-between"
            >
              <h4 class="m-0">{{ edu.organizationName }}</h4>
              <button-component
                v-if="!isReadonly"
                class="justify-content-center btn-sm card-footer__btn white m-2 width-auto"
                @click="deleteOrganization(edu.id + (edu.internalId ?? 0))"
                >Удалить
              </button-component>
            </div>
            <div class="row d-flex align-items-center">
              <div class="form-group col-3">
                <label class="control-label">Тип ОУ</label>
                <ComponentInput
                  v-bind:modelValue="edu.organizationType"
                  :disabled="true"
                />
              </div>
              <div class="form-group col-8 required" v-if="!edu.readOnly">
                <component-input
                  label="Наименование ОУ"
                  scopeName="tabCommonEdu"
                  type="select2"
                  required
                  :select2Options="commonEduOrgs"
                  :select2Settings="select2Settings"
                  v-model="edu.organizationId"
                  v-on:select2OnSelect="updateEduOrgName"
                  :additionalData="edu"
                />
              </div>
              <div class="form-group col-8 required" v-else>
                <component-input
                  label="Наименование ОУ"
                  scopeName="tabCommonEdu"
                  required
                  v-model="edu.organizationName"
                />
              </div>
              <div class="col-1 pt-3">
                <a
                  :href="`#/organizations/view/${edu.organizationId}`"
                  v-show="!!edu.organizationId"
                  class="btn p-0"
                  target="_blank"
                  ><i class="fas fa-eye"></i
                ></a>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-3 required">
                <label class="control-label">Дата поступления в ОУ</label>
                <date-component
                  :clearable="false"
                  :notFuture="true"
                  :disabled="isReadonly"
                  required
                  v-model="edu.receiptDate"
                  scopeName="tabCommonEdu"
                />
              </div>
              <div class="form-group col-4 required">
                <component-input
                  label="Форма обучения"
                  scopeName="tabCommonEdu"
                  type="select2"
                  :select2Options="educationForms"
                  :select2Settings="select2Settings"
                  v-model="edu.educationFormId"
                  required
                />
              </div>
              <div class="form-group col-5 required">
                <component-input
                  label="Уровень образования"
                  scopeName="tabCommonEdu"
                  type="select2"
                  required
                  :ref="'edu_level_' + index"
                  :select2Options="educationLevels"
                  :select2Settings="select2Settings"
                  v-model="edu.educationLevelId"
                  v-on:select2OnSelect="loadClassDictionaries"
                  :additionalData="{ index: index }"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 select2 required">
                <component-input
                  label="Вид класса/группы обучения"
                  scopeName="tabCommonEdu"
                  type="select2"
                  required
                  :select2Options="classKinds[index]"
                  :select2Settings="select2Settings"
                  v-model="edu.classKindId"
                />
              </div>
            </div>
            <div class="general-info">
              <div v-for="(cls, clsIndex) in edu.classLevels" class="row">
                <div class="form-group col-12 select2 required">
                  <div
                    class="d-flex flex-wrap align-items-center required"
                    v-if="clsIndex == 0"
                  >
                    <label class="control-label" required
                      >Уровень класса/группы обучения</label
                    >
                    <i
                      v-if="!edu.readOnly"
                      class="fa fa-plus ml-2 mb-2"
                      @click="addClassLevel(edu)"
                    ></i>
                  </div>
                  <div class="d-flex flex-wrap align-items-center">
                    <i
                      class="fa fa-trash"
                      v-if="
                        !edu.readOnly &&
                        edu.classLevels &&
                        edu.classLevels.length > 1
                      "
                      @click="deleteClassLevel(edu, clsIndex)"
                    ></i>
                    <div class="col-8">
                      <component-input
                        scopeName="tabCommonEdu"
                        type="select2"
                        required
                        :select2Options="classLevels[index]"
                        :select2Settings="select2Settings"
                        v-model="cls.classLevelId"
                        v-on:select2OnSelect="onClassLevelChanged"
                        :additionalData="{ edu }"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="general-info">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex flex-wrap align-items-center">
                    <label class="control-label"
                      >Получение услуг специалистов</label
                    >
                    <i
                      v-if="!edu.readOnly"
                      class="fa fa-plus ml-2 mb-2"
                      @click="addSpec(edu)"
                    ></i>
                  </div>
                </div>
                <div
                  v-for="(spec, specIndex) in edu.specialists"
                  :key="spec.id"
                  class="row"
                >
                  <div class="form-group col-12 select2">
                    <div class="d-flex flex-wrap align-items-center">
                      <i
                        v-if="!edu.readOnly"
                        class="fa fa-trash"
                        @click="deleteSpec(edu, specIndex)"
                      ></i>
                      <div class="col-4">
                        <Select2
                          class="select2"
                          :options="spec.specialistsList"
                          :settings="select2Settings"
                          v-model="spec.specialistId"
                          v-on:select="updateSpecialistsList(edu, spec)"
                          placeholder="Не указано"
                        />
                        <component-input
                          scopeName="tabCommonEdu"
                          type="select2"
                          v-if="false"
                          :select2Options="specialists"
                          :select2Settings="select2Settings"
                          v-model="spec.specialistId"
                        />
                      </div>
                      <div class="col-7">
                        <component-input
                          v-if="spec.specialistId > 2"
                          scopeName="tabCommonEdu"
                          v-model="spec.description"
                          :placeholder="getSpecPlaceholder()"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-4">
                <label class="control-label"
                  >Дата завершения обучения в ОУ</label
                >
                <date-component
                  :clearable="true"
                  :notFuture="true"
                  scopeName="tabCommonEdu"
                  :disabled="isReadonly"
                  v-model="edu.completionDate"
                />
              </div>
            </div>
          </div>
          <div class="card-footer mt-5">
            <div class="d-flex align-items-center float-right">
              <button-component
                class="btn btn-primary mx-2 width-auto"
                v-on:click="saveEdu(1)"
                v-if="!isReadonly"
                >Сохранить</button-component
              >
              <button-component
                kind="secondary"
                type="button"
                class="btn btn-default width-auto"
                v-on:click="close"
                data-ignore-disable="true"
                >Закрыть</button-component
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'active show': isActive('tabAddEdu') }"
        id="tabAddEdu"
        v-disable-all="isReadonly"
      >
        <div class="general-info">
          <button-component
            class="btn btn-primary mx-2 my-2 width-auto"
            v-on:click="addOrganization(EducationAdditional)"
          >
            Добавить ОУ
          </button-component>
          <div
            v-for="edu in additionalEducations"
            class="general-info__wrapper border-bottom mb-4 pb-4"
          >
            <div
              class="form-group d-flex flex-wrap align-items-center solid pl-3 justify-content-between"
            >
              <h4 class="m-0">{{ edu.organizationName }}</h4>
              <button-component
                v-if="!isReadonly"
                class="justify-content-center btn-sm card-footer__btn white m-2 width-auto"
                @click="deleteOrganization(edu.id + (edu.internalId ?? 0))"
                >Удалить
              </button-component>
            </div>
            <div class="row d-flex align-items-center">
              <div class="form-group col-11 select2 required">
                <component-input
                  label="Наименование ОУ"
                  scopeName="tabAddEdu"
                  type="select2"
                  required
                  :select2Options="addEduOrgs"
                  :select2Settings="select2Settings"
                  v-model="edu.organizationId"
                  v-on:select2OnSelect="updateEduOrgName"
                  :additionalData="edu"
                />
              </div>
              <div class="col-1 pt-3">
                <a
                  :href="`#/organizations/view/${edu.organizationId}`"
                  v-show="!!edu.organizationId"
                  class="btn p-0"
                  target="_blank"
                  ><i class="fas fa-eye"></i
                ></a>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-4 required">
                <label class="control-label">Дата поступления в ОУ</label>
                <date-component
                  :clearable="false"
                  :required="true"
                  :disabled="isReadonly"
                  v-model="edu.receiptDate"
                  scopeName="tabAddEdu"
                />
              </div>
              <div class="form-group col-8 required">
                <component-input
                  label="Направленность программы"
                  scopeName="tabAddEdu"
                  type="select2"
                  required
                  :select2Options="directionPrograms"
                  :select2Settings="select2Settings"
                  v-model="edu.directionProgramId"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 select2 required">
                <component-input
                  label="Вариант программы ДО"
                  scopeName="tabAddEdu"
                  type="select2"
                  required
                  :select2Options="additionalEducationalPrograms"
                  :select2Settings="select2Settings"
                  v-model="edu.educationalProgramId"
                />
              </div>
            </div>
            <div class="general-info">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex flex-wrap align-items-center">
                    <label class="control-label"
                      >Получение услуг специалистов</label
                    >
                    <i class="fa fa-plus ml-2 mb-2" @click="addSpec(edu)"></i>
                  </div>
                </div>
                <div
                  v-for="(spec, specIndex) in edu.specialists"
                  :key="spec.id"
                  class="row"
                >
                  <div class="form-group col-12 select2">
                    <div class="d-flex flex-wrap align-items-center">
                      <i
                        class="fa fa-trash"
                        @click="deleteSpec(edu, specIndex)"
                      ></i>
                      <div class="col-4">
                        <Select2
                          class="select2"
                          :options="spec.specialistsList"
                          :settings="select2Settings"
                          v-model="spec.specialistId"
                          v-on:select="updateSpecialistsList(edu, spec)"
                          placeholder="Не указано"
                        />
                        <component-input
                          scopeName="tabAddEdu"
                          type="select2"
                          v-if="false"
                          :select2Options="addSpecialistLists[specIdx]"
                          :select2Settings="select2Settings"
                          v-model="spec.specialistId"
                          v-on:select2OnSelect="updateSpecialistsList"
                          :additionalData="{
                            spec,
                            edu,
                            eduIdx: idx,
                            specIdx: specIndex,
                          }"
                        />
                      </div>
                      <div class="col-7">
                        <component-input
                          v-if="spec.specialistId > 2"
                          scopeName="tabAddEdu"
                          v-model="spec.description"
                          :placeholder="getSpecPlaceholder()"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-4">
                <label class="control-label"
                  >Дата завершения обучения в ОУ</label
                >
                <date-component
                  :clearable="false"
                  :disabled="isReadonly"
                  v-model="edu.completionDate"
                  scopeName="tabAddEdu"
                />
              </div>
            </div>
          </div>

          <!-- согласие после блоков -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="control-label"
                  >Согласие на внесение в Регистр ЛРАС</label
                >
                <file-upload
                  width="300px"
                  :entity="item"
                  @deleteFile="removeConsentToAddFile"
                  prop-name="consentToAdd"
                  @uploaded="consentToAddFileUploaded"
                />
              </div>
            </div>
          </div>
          <div class="card-footer mt-5">
            <div class="d-flex align-items-center float-right">
              <button-component
                class="btn btn-primary mx-2 width-auto"
                v-on:click="saveEdu(2)"
                v-if="!isReadonly"
                >Сохранить</button-component
              >
              <button-component
                kind="secondary"
                type="button"
                class="btn btn-default width-auto"
                v-on:click="close"
                data-ignore-disable="true"
                >Закрыть</button-component
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'active show': isActive('tabProfEdu') }"
        id="tabProfEdu"
        v-disable-all="isReadonly"
      >
        <button-component
          class="btn btn-primary mx-2 my-2 width-auto"
          :disabled="!checkAddProfEduAvailable(professionalEducations)"
          v-on:click="addOrganization(EducationProfessional)"
          >Добавить ОУ
        </button-component>
        <div
          v-for="edu in professionalEducations"
          class="general-info__wrapper border-bottom mb-4 pb-4"
        >
          <div class="row d-flex align-items-center">
            <div
              class="form-group d-flex flex-wrap solid pl-3 align-items-center justify-content-between"
            >
              <h4>{{ edu.organizationName }}</h4>
              <button-component
                v-if="!isReadonly"
                class="justify-content-center btn-sm card-footer__btn white m-2 width-auto"
                @click="deleteOrganization(edu.id + (edu.internalId ?? 0))"
                >Удалить
              </button-component>
            </div>
            <div class="form-group col-11 select2 required">
              <component-input
                label="Уровень проф. образования"
                scopeName="tabProfEdu"
                type="select2"
                required
                :select2Options="profEducationLevels"
                :select2Settings="select2Settings"
                v-model="edu.profEducationLevelId"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 select2 required">
              <component-input
                label="Наименование ОУ"
                scopeName="tabProfEdu"
                type="select2"
                required
                :select2Options="profEduOrgs"
                :select2Settings="select2Settings"
                v-model="edu.organizationId"
                v-on:select2OnSelect="updateEduOrgName"
                :additionalData="edu"
              />
            </div>
          </div>
          <div class="row" v-if="Number(edu.organizationId) === -1">
            <div
              :class="
                'form-group col-12' +
                (Number(edu.organizationId) === -1 ? ' required' : '')
              "
            >
              <ComponentInput
                v-model="edu.organizationName"
                :required="Number(edu.organizationId) === -1"
                scopeName="tabProfEdu"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4 required">
              <label class="control-label">Дата поступления в ОУ</label>
              <date-component
                :clearable="false"
                :required="true"
                :disabled="isReadonly"
                v-model="edu.receiptDate"
                scopeName="tabProfEdu"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label class="control-label">Дата завершения обучения в ОУ</label>
              <date-component
                :clearable="false"
                :disabled="isReadonly"
                v-model="edu.completionDate"
                scopeName="tabProfEdu"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12">
              <ComponentInput
                v-model="edu.documentInfo"
                scopeName="tabProfEdu"
                label="Документ об образовании"
              />
            </div>
          </div>
        </div>
        <div class="card-footer mt-5">
          <div class="d-flex align-items-center float-right">
            <button-component
              class="btn btn-primary mx-2 width-auto"
              v-on:click="saveEdu(3)"
              v-if="!isReadonly"
              >Сохранить</button-component
            >
            <button-component
              kind="secondary"
              type="button"
              class="btn btn-default width-auto"
              v-on:click="close"
              data-ignore-disable="true"
              >Закрыть</button-component
            >
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'active show': isActive('tabProf') }"
        id="tabProf"
        v-disable-all="isReadonly"
      >
        <button-component
          class="btn btn-primary mx-2 my-2 width-auto"
          v-on:click="addJob()"
          >Добавить место работы
        </button-component>
        <div class="general-info">
          <div v-for="(emp, index) in item.employments" class="row">
            <div
              class="form-group d-flex flex-wrap align-items-center solid justify-content-between"
            >
              <h5 class="m-0">{{ emp.organizationName }}</h5>
              <button-component
                v-if="!isReadonly"
                class="justify-content-center btn-sm card-footer__btn white my-2 width-auto"
                @click="deleteJob(index)"
                >Удалить
              </button-component>
            </div>
            <div class="row">
              <div class="form-group col-2">
                <label class="control-label">Дата начала работы</label>
                <date-component
                  :disabled="isReadonly"
                  v-model="emp.beginDate"
                />
              </div>
              <div class="form-group col-2">
                <label class="control-label">Дата окончания работы</label>
                <date-component :disabled="isReadonly" v-model="emp.endDate" />
              </div>
              <div class="form-group col-8">
                <ComponentInput
                  v-model="emp.organizationName"
                  label="Наименование организации"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 mb-4 pb-4 border-bottom">
                <ComponentInput v-model="emp.position" label="Должность" />
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer mt-5">
          <div class="d-flex align-items-center float-right">
            <button-component
              class="btn btn-primary mx-2 width-auto"
              v-on:click="saveEmployments()"
              v-if="!isReadonly"
              >Сохранить</button-component
            >
            <button-component
              kind="secondary"
              type="button"
              class="btn btn-default width-auto"
              v-on:click="close"
              data-ignore-disable="true"
              >Закрыть</button-component
            >
          </div>
        </div>
      </div>
      <div class="card-footer mt-5" v-if="false">
        <div class="d-flex align-items-center float-right">
          <button-component
            class="btn btn-primary mx-2 width-auto"
            v-on:click="save"
            v-if="!isReadonly"
            >Сохранить</button-component
          >
          <button-component
            kind="secondary"
            type="button"
            class="btn btn-default width-auto"
            v-on:click="close"
            data-ignore-disable="true"
            >Закрыть</button-component
          >
        </div>
      </div>
    </div>
  </div>
  <section class='modals'>
    <modal-component v-if="modals.pmpkConclusion" title="Заключение ПМПК" size-class="modal-xl"
                     @close="modals.pmpkConclusion = false">
      <pmpk-conclusion-card 
        :id="modals.pmpkConclusionId" 
        :readonly="modals.pmpkConclusionReadonly" 
        :journalId="journalId"
        :pmpkId="item.id"
        @close="modals.pmpkConclusion = false"
        @save="saveConclusionFromCard" />
    </modal-component>
  </section>
</template>

<script>
import NsiApi from "../../admin/api/nsi";
import Api from "../api/pmpk";
import OrgApi from "../../organization/api/organizations";
import DateComponent from "../../../common/components/DateComponent";
import Constants from "../../../common/constants";
import ComponentInput from "../../../common/components/ComponentInput";
import FileUpload from "../../../common/components/FileUpload";
import ButtonComponent from "../../../common/ui/ButtonComponent";
import { useVuelidate } from "@vuelidate/core";
import { maxLength, required, requiredIf } from "@vuelidate/validators";
import disableAll from "../../../common/directives/disable-all";
import UserApi from "@/modules/admin/api/users";
import PmpkConclusionCard from '../views/PmpkConclusionCard.vue';
import ModalComponent from "@/common/ui/ModalComponent";
import MenuComponent from "@/common/ui/components/page/MenuComponent";

export default {
  name: "JournalPmpk",
  components: { ButtonComponent, FileUpload, ComponentInput, DateComponent, PmpkConclusionCard, ModalComponent, MenuComponent },
  directives: {
    "disable-all": disableAll,
  },
  props: {
    journalId: Number,
    isReadonly: Boolean,
    parsedStatusOfChange: Object,
    //needSave: {
    //  type: Number,
    //  default: 0
    //}
  },
  data() {
    return {
      EducationCommon: 1,
      EducationAdditional: 2,
      EducationProfessional: 3,
      EducationLevelAdditional: 6,
      OrgTypePreschoolEducation: 1,
      OrgTypeCommonEducation: 2,
      OrgTypeProfEducation: 3,
      OrgTypeAddEducation: 4,
      activeItem: "tabConclusion",
      educationLevels: [],
      educationalPrograms: [],
      additionalEducationalPrograms: [],
      directionPrograms: [],
      profEducationLevels: [],
      repeatPeriods: [],
      specialists: [],
      eduSpecialists: [],
      specialTutorials: [],
      specialTso: [],
      commonEduOrgs: [],
      addEduOrgs: [],
      profEduOrgs: [],
      educationForms: [],
      classKinds: [],
      classLevels: [],
      pmpkPlacements: [],
      districts: [],
      realizationTerms: [],
      recom: {
        speechtherapy: [],
        pedagogical: [],
        psychological: [],
      },
      select2Settings: Constants.select2Settings,
      eduLevelId: null,
      conclusionArchiveVisible: false,
      conclusionArchive: [],
      currentConclusion: null,
      item: {
        id: 0,
        consentToAdd: null,
        consentToAddId: null,
        conclusion: {},
        documents: [],
        educations: [],
        employments: [],
        conclusions: [],
      },
      tabConclusionInvalid: false,
      tabSiprIomAopInvalid: false,
      tabCommonEduInvalid: false,
      tabAddEduInvalid: false,
      tabProfEduInvalid: false,
      tabProfInvalid: false,
      newEduId: -1,
      userOrgs: [],
      specLeft: [],
      addSpecialistLists: [],

      modals: {
        pmpkConclusion: false,
        pmpkConclusionId: null,
        pmpkConclusionReadonly: false,
        pmpkConclusionInProgress: false,
      }
    };
  },
  created() {
    this.item.journalId = this.journalId;
    this.item.conclusion = this.conclusionTemplate;
    this.loadDictionaries();
  },
  watch: {
    //needSave: function () {
    //  console.log('-------- pmpk need save')
    //  this.save();
    //}
  },
  methods: {
    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
    },
    close() {
      this.$router.push({ name: "Journal", query: { page1: this.$route.query.page1 } });
    },
    loadDictionaries() {
      NsiApi.getNsi("pmpkplacement").then((response) => {
        this.pmpkPlacements = response.data;
      });
      NsiApi.getNsi("district").then((response) => {
        this.districts = response.data;
      });
      NsiApi.getNsi("realizationterm").then((response) => {
        this.realizationTerms = response.data;
      });
      NsiApi.getNsi("specialist").then((response) => {
        this.specialists = response.data;
        this.loadCard();
      });
      NsiApi.getNsi("educationlevel").then((response) => {
        this.educationLevels = response.data;
      });
      NsiApi.getNsi("repeatperiod").then((response) => {
        this.repeatPeriods = response.data;
      });
      NsiApi.getNsi("specialtutorial").then((response) => {
        this.specialTutorials = response.data;
      });
      NsiApi.getNsi("specialtso").then((response) => {
        this.specialTso = response.data;
      });
      NsiApi.getNsi("educationform").then((response) => {
        this.educationForms = response.data;
      });
      NsiApi.getNsi("profeducationlevel").then((response) => {
        this.profEducationLevels = response.data;
      });
      NsiApi.getEducationalPrograms(this.EducationLevelAdditional).then(
        (response) => {
          this.additionalEducationalPrograms = response.data;
        }
      );
      NsiApi.getNsi("directionPrograms").then((response) => {
        this.directionPrograms = response.data;
      });

      OrgApi.search({
        pageNumber: 0,
        pageSize: -1,
        kindActivityId: Constants.KindActivityEducation,
        organizationTypeId: this.OrgTypePreschoolEducation,
      }).then((response) => {
        this.commonEduOrgs = response.data.items.map((x) => ({
          id: x.id,
          text: x.name,
          typeName: x.typeName,
        }));
        OrgApi.search({
          pageNumber: 0,
          pageSize: -1,
          kindActivityId: Constants.KindActivityEducation,
          organizationTypeId: this.OrgTypeCommonEducation,
        }).then((response) => {
          this.commonEduOrgs = this.commonEduOrgs.concat(
            response.data.items.map((x) => ({
              id: x.id,
              text: x.name,
              typeName: x.typeName,
            }))
          );
          OrgApi.search({
            pageNumber: 0,
            pageSize: -1,
            kindActivityId: Constants.KindActivityEducation,
            organizationTypeId: this.OrgTypeAddEducation,
          }).then((response) => {
            this.addEduOrgs = this.commonEduOrgs.concat(
              response.data.items.map((x) => ({ id: x.id, text: x.name }))
            );
          });
        });
      });

      OrgApi.search({
        pageNumber: 0,
        pageSize: -1,
        kindActivityId: Constants.KindActivityEducation,
        organizationTypeId: this.OrgTypeProfEducation,
      }).then((response) => {
        this.profEduOrgs = response.data.items.map((x) => ({
          id: x.id,
          text: x.name,
        }));
        this.profEduOrgs.push({
          id: -1,
          text: "Иная организация (вне Нижегородской области)",
        });
      });
    },
    loadEducationalPrograms() {
      if (!this.eduLevelId) {
        return;
      }
      NsiApi.getEducationalPrograms(this.eduLevelId).then((response) => {
        this.educationalPrograms = response.data;
      });
    },
    loadRecommendations() {
      if (!this.item.conclusion.educationalProgramId) {
        return;
      }
      const recom = ["speechtherapy", "pedagogical", "psychological"];
      recom.forEach((rec) => {
        NsiApi.getRecommedations(
          rec,
          this.item.conclusion.educationalProgramId
        ).then((response) => {
          this.recom[rec] = response.data;
        });
      });
    },
    loadClassKinds(id, index) {
      NsiApi.getClassKinds(id).then((response) => {
        this.classKinds[index] = response.data;
      });
    },
    loadClassLevels(id, index) {
      NsiApi.getClassLevels(id).then((response) => {
        this.classLevels[index] = response.data;
      });
    },
    loadClassDictionaries(data) {
      this.loadClassKinds(data.value.id, data.additional.index);
      this.loadClassLevels(data.value.id, data.additional.index);
    },
    initializeNestedDicts() {
      this.item.educations
        .filter((x) => x.educationType === this.EducationCommon)
        .forEach((item, idx) => {
          var data = {
            value: { id: item.educationLevelId },
            additional: { index: idx },
          };
          this.loadClassDictionaries(data);
          // const ddl = this.$refs['edu_level_' + idx];
          // if (ddl && typeof (ddl.setValue) === 'function') {
          //   ddl.setValue('');
          //   this.$nextTick(() => {
          //     if (ddl)
          //       ddl.setValue(item.educationLevelId);
          //   });
          // }
        });
      this.loadEducationalPrograms();
      this.loadRecommendations();
    },
    loadCard() {
      UserApi.currentUserOrgs().then((res) => {
        this.userOrgs = res.data;
        var isYar = res.data && res.data.length == 1 && res.data[0].id == "-1";
        Api.search({ journalId: this.journalId }).then((response) => {
          if (response.data && Object.keys(response.data).length) {
            this.item.id = response.data.id;
            this.item.journalId = response.data.journalId;
            this.item.consentToAdd = response.data.consentToAdd;
            this.item.consentToAddId = response.data.consentToAddId;
            this.item.created = response.data.created;
            this.item.conclusions = response.data.conclusions;
            if (response.data.conclusion) {
              this.item.conclusion = response.data.conclusion;
              this.eduLevelId =
                this.item.conclusion.educationalProgram?.educationLevelId;
            }
            this.conclusionArchive = response.data.conclusionArchive;
            this.item.documents = response.data.documents;
            this.item.educations = response.data.educations;
            this.item.employments = response.data.employments;
            this.initializeNestedDicts();

            if (!isYar)
              this.item.educations.forEach((x) => {
                x.readOnly =
                  this.userOrgs.findIndex((o) => o.id == x.organizationId) ==
                  -1;
              });

            this.item.educations
              .filter(
                (x) =>
                  x.educationType === this.EducationCommon ||
                  x.educationType === this.EducationAdditional
              )
              .forEach((x) => {
                this.fillSpecialistsLists(x);
              });

            //this.initSpecialistData(false);
            this.mapLists(false);
          }
        });
      });
    },

    fillSpecialistsLists(x) {
      if ((!x.specialists || x.specialists.length == 0) && !x.readOnly) {
        x.specLeft = this.specialists;
        x.specialists.push({
          id: 0,
          specialistsList: Object.assign([], this.specialists),
        });
      } else {
        var specListUsed = [];
        x.specLeft = [];

        x.specialists.forEach((s2) => {
          if (specListUsed.findIndex((ss) => ss == s2.specialistId) == -1)
            specListUsed.push(s2.specialistId);
        });

        this.specialists.forEach((s) => {
          var idx = specListUsed.findIndex((s1) => s1 == s.id);
          if (idx == -1) x.specLeft.push(s);
        });

        x.specialists.forEach((s3) => {
          s3.specialistsList = [];
          x.specLeft.forEach((s) => {
            s3.specialistsList.push(s);
          });

          if (s3.specialistId || s3.specialist) {
            var sId = s3.specialistId ?? s3.specialist.id;
            if (s3.specialistsList.findIndex((s1) => s1 == sId) == -1) {
              var found = this.specialists.find((f) => f.id == sId);
              if (found)
                s3.specialistsList.unshift({
                  id: found.id,
                  text: found.text,
                  selected: true,
                });
            }
          }
        });
      }
      return x.specialists;
    },

    addFile() {
      var attachedFile = { journalPmpkConclusionId: this.id, fileId: 0 };
      this.item.conclusion.files = [
        ...this.item.conclusion.files,
        attachedFile,
      ];
    },
    removeFile(idx) {
      this.item.conclusion.files.splice(idx, 1);
    },
    removeFileSipr(doc) {
      doc.fileId = 0;
      doc.file = {};
    },
    fileUploaded(e) {
      let entity = this.item.conclusion.files[e.entityIndex];
      entity[e.propName + "Id"] = e.data.id;
      entity[e.propName] = e.data;
    },
    conclusionCopyFileUploaded(e) {
      this.item.conclusion.conclusionCopy = e.data;
      this.item.conclusion.conclusionCopyId = e.data ? e.data.id : null;
    },
    removeConclusionCopyFile() {
      this.item.conclusion.conclusionCopyId = null;
      this.item.conclusion.conclusionCopy = null;
    },
    conclusionConsentCopyFileUploaded(e) {
      this.item.conclusion.parentConsent = e.data;
      this.item.conclusion.parentConsentId = e.data ? e.data.id : null;
    },
    removeConclusionConsentFile() {
      this.item.conclusion.parentConsentId = null;
      this.item.conclusion.parentConsent = null;
    },
    conclusionConsentToAddFileUploaded(e) {
      this.item.conclusion.consentToAdd = e.data;
      this.item.conclusion.consentToAddId = e.data ? e.data.id : null;
    },
    removeConclusionConsentToAddFile() {
      this.item.conclusion.consentToAdd = null;
      this.item.conclusion.consentToAddId = null;
    },
    consentToAddFileUploaded(e) {
      this.item.consentToAdd = e.data;
      this.item.consentToAddId = e.data ? e.data.id : null;
    },
    removeConsentToAddFile() {
      this.item.consentToAdd = null;
      this.item.consentToAddId = null;
    },
    checkAddEduAvailable(eduArray) {
      if (!eduArray || eduArray.length == 0) return true;
      var res = true;
      eduArray.forEach((e) => {
        if (!e.completionDate) res = false;
      });
      return res;
    },
    checkAddProfEduAvailable(eduArray) {
      if (!eduArray || eduArray.length == 0) return true;
      var res = true;
      eduArray.forEach((e) => {
        if (!e.documentInfo || e.documentInfo.trim().length === 0) res = false;
      });
      return res;
    },
    updateEduOrgName(data) {
      data.additional.organizationName = data.value
        ? data.value.id == -1
          ? null
          : data.value.text
        : "";
      data.additional.organizationType = data.value
        ? data.value.id == -1
          ? ""
          : this.getCommonOrgType(data.value.id)
        : "";
    },
    updateSpecialistsList(edu, spec) {
      this.fillSpecialistsLists(edu);
      if (spec.specialistId <= 2) spec.description = "";
    },
    addEducation(type) {
      const edu = {
        id: 0,
        internalId: this.newEduId,
        journalPmpkId: this.item.id,
        educationType: type,
        profEducationLevelId: null,
        organizationId: null,
        organizationName: null,
        receiptDate: null,
        educationFormId: null,
        educationLevelId: null,
        classKindId: null,
        classLevels: [],
        educationalProgramId: null,
        completionDate: null,
        documentInfo: null,
        specialists: [{ id: 0, specialistsList: this.specialists }],
        specialistData: [],
        specLeft: this.specialists,
      };
      this.item.educations.unshift(edu);
      if (type === this.EducationCommon) {
        edu.classLevels.push({
          journalPmpkEducationId: edu.id,
          classLevelId: null,
        });
      }
      this.newEduId--;
      //this.initSpecialistData(true);
      //console.log(this.item)
    },
    addClassLevel(edu) {
      edu.classLevels.unshift({
        journalPmpkEducationId: edu.id,
        classLevelId: null,
      });
    },
    onClassLevelChanged(data) {
      if (data.value) {
        var indices = data.additional.edu.classLevels
          .map((e, i) => (e.classLevelId == data.value.id ? i : ""))
          .filter(String);
        if (indices.length > 1)
          data.additional.edu.classLevels.splice(indices[0], 1);
      }
    },
    deleteClassLevel(edu, idx) {
      edu.classLevels.splice(idx, 1);
    },
    addOrganization(type) {
      if (
        type === this.EducationCommon &&
        !this.checkAddEduAvailable(this.commonEducations)
      )
        Constants.alert.fire(
          "Внимание",
          "Нельзя добавить новое ОУ, если на заполнена дата окончания у предыдущего",
          "error"
        );
      else this.addEducation(type);
    },
    deleteOrganization(eduId) {
      var idx;
      if (eduId < 0)
        idx = this.item.educations.findIndex((e) => e.internalId == eduId);
      else idx = this.item.educations.findIndex((e) => e.id == eduId);
      if (idx >= 0) this.item.educations.splice(idx, 1);
    },
    addJob() {
      this.item.employments.push({
        id: 0,
        journalPmpkId: this.item.id,
        beginDate: null,
        endDate: null,
        organizationName: null,
        position: null,
      });
    },
    deleteJob(idx) {
      this.item.employments.splice(idx, 1);
    },
    addSpec(edu) {
      edu.specialists.unshift({ id: 0, specialistsList: edu.specLeft });
    },
    deleteSpec(edu, idx) {
      edu.specialists.splice(idx, 1);
      this.fillSpecialistsLists(edu);
    },
    addDocument() {
      this.item.documents.unshift({
        id: 0,
        journalPmpkId: this.item.id,
        documentDate: null,
        documentNumber: null,
        comment: null,
        fileId: 0,
        file: {},
      });
    },
    deleteDocument(idx) {
      this.item.documents.splice(idx, 1);
    },
    documentFileUploaded(e) {
      let entity = this.item.documents[e.entityIndex];
      entity[e.propName + "Id"] = e.data.id;
      entity[e.propName] = e.data;
    },
    createConclusionVersion() {
      Api.archiveConclusion(this.item.conclusion.id)
        .then(() => {
          this.item.conclusion = this.conclusionTemplate;
          Constants.alert.fire(
            "Успешно",
            "Текущее заключение отправлено в архив.",
            "success"
          );
          this.reloadConclusionArchive();
          this.scrollCardToTop();
        })
        .catch((response) => {
          console.log(response);
          Constants.alert.fire(
            "Ошибка",
            "Не удалось создать версию заключения.",
            "error"
          );
        });
    },
    reloadConclusionArchive() {
      Api.search({ journalId: this.journalId }).then((response) => {
        this.conclusionArchive = response.data.conclusionArchive;
      });
    },
    toggleConclusionArchive() {
      this.conclusionArchiveVisible = !this.conclusionArchiveVisible;
    },
    openArchivedConclusion(entry) {
      if (!this.currentConclusion) {
        this.currentConclusion = this.item.conclusion;
      }
      this.item.conclusion = entry;
      this.eduLevelId =
        this.item.conclusion.educationalProgram?.educationLevelId;
      this.loadEducationalPrograms();
      this.loadRecommendations();
      this.mapLists(false);
      this.scrollCardToTop();
    },
    closeArchivedConclusion() {
      this.item.conclusion = this.currentConclusion;
      this.currentConclusion = null;
      this.eduLevelId =
        this.item.conclusion.educationalProgram?.educationLevelId;
      this.loadEducationalPrograms();
      this.loadRecommendations();
      this.scrollCardToTop();
    },
    save() {
      if (this.item.conclusion.isArchive) {
        Constants.alert.fire(
          "Ошибка",
          "Закройте архивное заключение перед сохранением.",
          "error"
        );
        return;
      }
      this.tabConclusionInvalid = false;
      this.tabSiprIomAopInvalid = false;
      this.tabAddEduInvalid = false;
      this.tabProfEduInvalid = false;
      this.tabProfInvalid = false;
      this.tabCommonEduInvalid = false;

      //console.log(this.$refs.formSiprIomAop);
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.v$.$errors.forEach((e) => {
          if (
            e.$propertyPath.includes("item.conclusion") ||
            (e.$response.extraParams &&
              e.$response.extraParams.scope === "tabConclusion")
          ) {
            this.tabConclusionInvalid = true;
          }
          if (
            e.$response.extraParams &&
            e.$response.extraParams.scope === "tabSiprIomAop"
          ) {
            this.tabSiprIomAopInvalid = true;
          }
          if (
            e.$response.extraParams &&
            e.$response.extraParams.scope === "tabCommonEdu"
          ) {
            this.tabCommonEduInvalid = true;
          }
          if (
            e.$response.extraParams &&
            e.$response.extraParams.scope === "tabAddEdu"
          ) {
            this.tabAddEduInvalid = true;
          }
          if (
            e.$response.extraParams &&
            e.$response.extraParams.scope === "tabProfEdu"
          ) {
            this.tabProfEduInvalid = true;
          }
        });
        Constants.alert.fire(
          "Ошибка",
          "Проверьте правильность заполнения полей",
          "error"
        );
        //this.$emit('journalPmpkInvalid');
        return;
      }

      this.mapLists(true);
      //console.log(this.item, '---------- item to save')
      if (this.item.id) {
        Api.update(this.item.id, this.item)
          .then(() => {
            Constants.alert
              .fire(
                "Сохранено",
                "Информация ПМПК успешно сохранена.",
                "success"
              )
              .then(() => {
                this.loadCard();
              });
            //this.$emit('journalPmpkSaved', true);
          })
          .catch((res) => {
            console.log(res);
            //this.$emit('journalPmpkSaved', false);
            Constants.alert.fire(
              "Ошибка",
              "Произошла ошибка при сохранении. " + res,
              "error"
            );
            this.resetCard();
          });
      } else {
        Api.create(this.item)
          .then(() => {
            Constants.alert.fire(
              "Добавлено",
              "Информация ПМПК успешно добавлена.",
              "success"
            );
            this.loadCard();
          })
          .catch((res) => {
            //console.log(res);
            Constants.alert.fire(
              "Ошибка",
              "Произошла ошибка при добавлении. " + res,
              "error"
            );
            this.resetCard();
          });
      }
    },

    saveEdu(eduType) {
      if (eduType == 1) this.tabCommonEduInvalid = false;
      else if (eduType == 2) this.tabAddEduInvalid = false;
      else if (eduType == 3) this.tabProfEduInvalid = false;

      //console.log(this.$refs.formSiprIomAop);
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.v$.$errors.forEach((e) => {
          if (
            eduType == 1 &&
            e.$response.extraParams &&
            e.$response.extraParams.scope === "tabCommonEdu"
          ) {
            this.tabCommonEduInvalid = true;
          }
          if (
            eduType == 2 &&
            e.$response.extraParams &&
            e.$response.extraParams.scope === "tabAddEdu"
          ) {
            this.tabAddEduInvalid = true;
          }
          if (
            eduType == 3 &&
            e.$response.extraParams &&
            e.$response.extraParams.scope === "tabProfEdu"
          ) {
            this.tabProfEduInvalid = true;
          }
        });
        if (
          this.tabCommonEduInvalid ||
          this.tabAddEduInvalid ||
          this.tabProfEduInvalid
        ) {
          Constants.alert.fire(
            "Ошибка",
            "Проверьте правильность заполнения полей",
            "error"
          );
          //this.$emit('journalPmpkInvalid');
          return;
        }
      }

      const educationsFiltered = this.item.educations.filter(
        (e) => e.educationType == eduType
      );
      this.mapLists(true);
      //console.log(this.item, '---------- item to save')

      var tabName = "";
      if (eduType == 1) tabName = "Дошкольное и общее образование";
      else if (eduType == 2) tabName = "Дополнительное образование";
      else if (eduType == 3) tabName = "Профессиональное образование";

      var saveMsg = `Данные вкладки "${tabName}" успешно сохранены`;
      var errMsg = `Произошла ошибка при сохранении вкладки "${tabName}". `;

      const itemBackup = Object.assign({}, this.item);
      const itemToSave = Object.assign({}, this.item);
      itemToSave.conclusion = null;
      itemToSave.documents = null;
      itemToSave.employments = null;
      itemToSave.educations = educationsFiltered;
      Api.saveEdu(this.item.id, itemToSave, eduType)
        .then(() => {
          Constants.alert.fire("Сохранено", saveMsg, "success").then(() => {
            this.loadCard();
            this.item.conclusion = itemBackup.conclusion;
            this.item.documents = itemBackup.documents;
            this.item.employments = itemBackup.employments;
          });
          //this.$emit('journalPmpkSaved', true);
        })
        .catch((res) => {
          console.log(res);
          //this.$emit('journalPmpkSaved', false);
          Constants.alert.fire("Ошибка", errMsg + res, "error");
          this.resetCard();
        });
    },

    saveConclusion() {
      if (this.item.conclusion.isArchive) {
        Constants.alert.fire(
          "Ошибка",
          "Закройте архивное заключение перед сохранением.",
          "error"
        );
        return;
      }
      this.tabConclusionInvalid = false;

      //console.log(this.$refs.formSiprIomAop);
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.v$.$errors.forEach((e) => {
          if (
            e.$propertyPath.includes("item.conclusion") ||
            (e.$response.extraParams &&
              e.$response.extraParams.scope === "tabConclusion")
          ) {
            this.tabConclusionInvalid = true;
          }
        });
      }

      if (this.tabConclusionInvalid) {
        Constants.alert.fire(
          "Ошибка",
          "Проверьте правильность заполнения полей",
          "error"
        );
        //this.$emit('journalPmpkInvalid');
        return;
      }

      this.mapLists(true);
      //console.log(this.item, '---------- item to save')

      var tabName = "Заключение";
      var saveMsg = `Данные вкладки "${tabName}" успешно сохранены`;
      var errMsg = `Произошла ошибка при сохранении вкладки "${tabName}". `;

      const itemBackup = Object.assign({}, this.item);
      const itemToSave = Object.assign({}, this.item);
      itemToSave.documents = null;
      itemToSave.employments = null;
      itemToSave.educations = null;

      Api.saveConclusion(this.item.id, itemToSave)
        .then(() => {
          Constants.alert.fire("Сохранено", saveMsg, "success").then(() => {
            this.loadCard();
            this.item.educations = itemBackup.educations;
            this.item.documents = itemBackup.documents;
            this.item.employments = itemBackup.employments;
          });
          //this.$emit('journalPmpkSaved', true);
        })
        .catch((res) => {
          console.log(res);
          //this.$emit('journalPmpkSaved', false);
          Constants.alert.fire("Ошибка", errMsg + res, "error");
          this.resetCard();
        });
    },

    saveEmployments() {
      this.tabProfInvalid = false;

      this.mapLists(true);
      //console.log(this.item, '---------- item to save')

      var tabName = "Трудоустройство";
      var saveMsg = `Данные вкладки "${tabName}" успешно сохранены`;
      var errMsg = `Произошла ошибка при сохранении вкладки "${tabName}". `;

      const itemBackup = Object.assign({}, this.item);
      const itemToSave = Object.assign({}, this.item);
      itemToSave.documents = null;
      itemToSave.conclusion = null;
      itemToSave.educations = null;

      Api.saveEmployments(this.item.id, itemToSave)
        .then(() => {
          Constants.alert.fire("Сохранено", saveMsg, "success").then(() => {
            this.loadCard();
            this.item.educations = itemBackup.educations;
            this.item.documents = itemBackup.documents;
            this.item.conclusion = itemBackup.conclusion;
          });
          //this.$emit('journalPmpkSaved', true);
        })
        .catch((res) => {
          console.log(res);
          //this.$emit('journalPmpkSaved', false);
          Constants.alert.fire("Ошибка", errMsg + res, "error");
          this.resetCard();
        });
    },

    saveDocuments() {
      this.tabSiprIomAopInvalid = false;

      this.v$.$touch();
      if (this.v$.$invalid) {
        this.v$.$errors.forEach((e) => {
          if (
            e.$response.extraParams &&
            e.$response.extraParams.scope === "tabCommonEdu"
          ) {
            this.tabSiprIomAopInvalid = true;
          }
        });
      }

      if (this.tabSiprIomAopInvalid) {
        Constants.alert.fire(
          "Ошибка",
          "Проверьте правильность заполнения полей",
          "error"
        );
        return;
      }

      this.mapLists(true);
      //console.log(this.item, '---------- item to save')

      var tabName = "СИПР/ИОМ/АОП";
      var saveMsg = `Данные вкладки "${tabName}" успешно сохранены`;
      var errMsg = `Произошла ошибка при сохранении вкладки "${tabName}". `;

      const itemBackup = Object.assign({}, this.item);
      const itemToSave = Object.assign({}, this.item);
      itemToSave.employments = null;
      itemToSave.conclusion = null;
      itemToSave.educations = null;

      Api.saveDocuments(this.item.id, itemToSave)
        .then(() => {
          Constants.alert.fire("Сохранено", saveMsg, "success").then(() => {
            this.loadCard();
            this.item.educations = itemBackup.educations;
            this.item.employments = itemBackup.employments;
            this.item.conclusion = itemBackup.conclusion;
          });
          //this.$emit('journalPmpkSaved', true);
        })
        .catch((res) => {
          console.log(res);
          //this.$emit('journalPmpkSaved', false);
          Constants.alert.fire("Ошибка", errMsg + res, "error");
          this.resetCard();
        });
    },

    resetCard() {
      //this.initSpecialistData(false);
      this.mapLists(false);
    },
    mapLists(forSave) {
      if (forSave) {
        this.item.conclusion.specialists = this.item.conclusion.specialists.map(
          (x) => ({ specialistId: x })
        );
        this.item.conclusion.specialTutorials =
          this.item.conclusion.specialTutorials.map((x) => ({
            specialTutorialId: x,
          }));
        this.item.conclusion.specialTso = this.item.conclusion.specialTso.map(
          (x) => ({ specialTsoId: x })
        );

        this.item.conclusion.recomPsychological =
          this.item.conclusion.recomPsychological.map((x) => ({
            recomPsychologicalId: x,
          }));
        this.item.conclusion.recomPedagogical =
          this.item.conclusion.recomPedagogical.map((x) => ({
            recomPedagogicalId: x,
          }));
        this.item.conclusion.recomSpeechTherapy =
          this.item.conclusion.recomSpeechTherapy.map((x) => ({
            recomSpeechTherapyId: x,
          }));

        this.item.conclusion.files = this.item.conclusion.files.filter(
          (x) => x.fileId
        );

        //this.item.educations
        //    .filter((x) => x.educationType === this.EducationCommon || x.educationType === this.EducationAdditional)
        //    .forEach((x) => {
        //      x.specialists = x.specialists
        //          .map((s) => ({specialistId: s, description: x.specialistData[s]?.description}));
        //    });

        //this.item.educations
        //    .filter((x) => x.educationType === this.EducationProfessional)
        //    .forEach((x) => {
        //      if (Number(x.organizationId) === -1) {
        //        x.organizationId = null;
        //      }
        //    });
      } else {
        if (this.item.conclusion.specialists.length) {
          this.item.conclusion.specialists =
            this.item.conclusion.specialists.map((x) => x.specialistId);
        }
        if (this.item.conclusion.specialTutorials.length) {
          this.item.conclusion.specialTutorials =
            this.item.conclusion.specialTutorials.map(
              (x) => x.specialTutorialId
            );
        }
        if (this.item.conclusion.specialTso.length) {
          this.item.conclusion.specialTso = this.item.conclusion.specialTso.map(
            (x) => x.specialTsoId
          );
        }
        if (this.item.conclusion.recomPsychological.length) {
          this.item.conclusion.recomPsychological =
            this.item.conclusion.recomPsychological.map(
              (x) => x.recomPsychologicalId
            );
        }
        if (this.item.conclusion.recomPedagogical.length) {
          this.item.conclusion.recomPedagogical =
            this.item.conclusion.recomPedagogical.map(
              (x) => x.recomPedagogicalId
            );
        }
        if (this.item.conclusion.recomSpeechTherapy.length) {
          this.item.conclusion.recomSpeechTherapy =
            this.item.conclusion.recomSpeechTherapy.map(
              (x) => x.recomSpeechTherapyId
            );
        }

        this.item.educations
          .filter((x) => x.educationType === this.EducationProfessional)
          .forEach((x) => {
            if (!x.organizationId) {
              x.organizationId = -1;
            }
          });
      }
    },
    initSpecialistData(isNew) {
      this.item.educations
        .filter(
          (x) =>
            x.educationType === this.EducationCommon ||
            x.educationType === this.EducationAdditional
        )
        .forEach((x) => {
          x.specialistData = {};
          this.specialists.forEach((s) => {
            x.specialistData[s.id] = { description: "" };
          });
          if (isNew) {
            return;
          }
          if (x.specialists.length) {
            x.specialists.forEach((s) => {
              x.specialistData[s.specialistId].description = s.description;
            });
            x.specialists = x.specialists.map((s) => s.specialistId);
          }
        });
    },
    getCommonOrgType(orgId) {
      const org = this.commonEduOrgs.find((x) => x.id === Number(orgId));
      return org?.typeName;
    },
    getSpecPlaceholder() {
      return `Введите объем услуг`;
    },
    scrollCardToTop() {
      document.getElementsByClassName("dashboard-page")[0].scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    compareEducations(a, b) {
      var d1 = (a.receiptDate ? new Date(a.receiptDate) : new Date()).getTime();
      var d2 = (b.receiptDate ? new Date(b.receiptDate) : new Date()).getTime();
      if (d1 < d2) return 1;
      if (d1 > d2) return -1;
      return 0;
    },

    actionsConclusion(item) {
      let result = [{
        title: 'Просмотр',
        icon: 'eye',
        click: () => this.openCardConclusion(item.id, true)
      }];
      if (!item.isArchive) {
        result.push({
          title: 'Редактировать',
          icon: 'pen',
          click: () => this.openCardConclusion(item.id, false)
        });
        result.push({
          title: 'В архив',
          icon: 'trash',
          click: () => this.archiveConclusion(item.id)
        });
      } else {
        result.push({
          title: 'Восстановить из архива',
          icon: 'trash-restore',
          click: () => this.restoreConclusion(item.id)
        });
      }
      return result;
    },
    archiveConclusion(conclusionId) {
      Api.archiveConclusion(conclusionId)
        .then(() => {
          this.reloadConclusionTable();
        })
        .catch((response) => {
          console.log(response);
          Constants.alert.fire(
            "Ошибка",
            "Не удалось отправить заключение в архив.",
            "error"
          );
        });
    },
    restoreConclusion(conclusionId) {
      Api.restoreConclusion(conclusionId)
        .then(() => {
          this.reloadConclusionTable();
        })
        .catch((response) => {
          console.log(response);
          Constants.alert.fire(
            "Ошибка",
            "Не удалось восстановить заключение из архива.",
            "error"
          );
        });
    },
    reloadConclusionTable() {
      this.modals.pmpkConclusionInProgress = true;
      Api.search({ journalId: this.journalId })
        .then((response) => {
            if (response.data && Object.keys(response.data).length) {
              this.item.conclusions = response.data.conclusions;
              this.item.id = response.data.id;
            }
        })
        .finally(() => {
          this.modals.pmpkConclusionInProgress = false;
        });
    },
    openCardConclusion(conclusionId, isReadonly) {
      this.modals.pmpkConclusionId = conclusionId;
      this.modals.pmpkConclusionReadonly = isReadonly;
      this.modals.pmpkConclusion = true;
      return false;
    },
    saveConclusionFromCard() {
      //закрываем модальное окно и обновляем только заключения
      this.modals.pmpkConclusion = false;
      this.reloadConclusionTable();
    }
  },
  computed: {
    commonEducations() {
      console.log(
        this.item.educations.filter(
          (x) => x.educationType === this.EducationCommon
        )
      );
      return this.item.educations
        .filter((x) => x.educationType === this.EducationCommon)
        .sort(this.compareEducations);
    },
    additionalEducations() {
      return this.item.educations
        .filter((x) => x.educationType === this.EducationAdditional)
        .sort(this.compareEducations);
    },
    professionalEducations() {
      return this.item.educations
        .filter((x) => x.educationType === this.EducationProfessional)
        .sort(this.compareEducations);
    },
    conclusionTemplate() {
      return {
        id: 0,
        passDate: null,
        number: "",
        pmpkPlacementId: null,
        districtId: null,
        educationalProgramId: null,
        realizationTermId: null,
        repeatPeriodId: null,
        files: [],
        specialTeachingMethods: "В соответствии с программой",
        specialTutorials: [],
        specialTso: [],
        specialists: [],
        specialConditions: null,
        recomPedagogical: [],
        recomPsychological: [],
        recomSpeechTherapy: [],
        recomGia: null,
        isArchive: false,
      };
    },
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      item: {
        conclusion: {
          number: {
            required,
            maxLength: maxLength(100),
          },
          passDate: {
            required,
          },
          pmpkPlacementId: {
            required,
          },
          districtId: {
            required: requiredIf(this.item.conclusion.pmpkPlacementId === "2"),
          },
          commissionConclusions: {
            required,
          },
          educationalProgramId: {
            required,
          },
          realizationTermId: {
            required,
          },
          repeatPeriodId: {
            required,
          },
          // parentConsentId: {
          //   required
          // },
          consentToAddId: {
            required,
          },
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.nav-tabs {
  .nav-item {
    .nav-link {
      display: flex;
      padding-bottom: 16px;
      height: 69px;
      justify-content: center;
      align-items: center;
      color: $black;
      font-weight: bold;
      border: none;
      border-bottom: 1px solid $blue-light;

      &.active {
        color: $blue-light;
      }
    }
  }
}

.select2::v-deep {
  .select2-container {
    width: 100% !important;
    max-width: 100% !important;
  }

  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;
  }

  .select2-container--default
    .select2-selection--single
    .select2-selection__arrow {
    top: 7px !important;
  }
}

.nav-tabs {
  justify-content: center;
  border: none;

  .nav-item {
    margin-top: 12px;
    max-width: 240px;
    width: 100%;

    &:not(:last-child) {
      margin-right: 16px;
    }

    .nav-link {
      padding: 14.5px 20px;
      text-align: center;
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      color: $gray-dark;
      border: 1px solid $gray-light1;
      box-sizing: border-box;
      border-radius: 6px;

      &.active {
        color: $blue-light;
        border: 1px solid $blue-light;
      }
    }
  }
}

.general-info h5 {
  margin-top: 20px;
}

.chk-spec-service {
  margin-right: 16px;
}

.btn-delete {
  padding-top: 32px;
  cursor: pointer;
}
.btn-addFile {
  margin-top: 16px;
  padding: 0;
  width: 100%;
  text-align: left;
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: $blue-light;
}
.form-group.required .control-label:after {
  content: " *";
  color: red;
}
.invalid-msg {
  color: red;
}
.solid {
  background-color: #f5f5fa; //rgba(171,171,179, 0.1);
  line-height: 3rem;
  letter-spacing: 0.5px;
}

.card-footer {
  padding: 0;
  background-color: transparent;
  border: none;
}
</style>
